import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {TogglerBtns} from "./toggler_btns"

export const togglerBtnsLoader = function (options = {}) {
    componentLoader(componentConfig(TogglerBtns, TogglerBtns.config.componentTypeKey, TogglerBtns.config.baseHtmlClass), options);
};

